import React from 'react';
import { useLocation } from 'react-router';
import { useQueryId, useSeriesId } from '@/hooks';
import { useAppDispatch } from '@/store/hooks';
import { setInitialPathname } from '../slice';

export const useSetInitialUrl = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const queryId = useQueryId();
  const seriesId = useSeriesId();

  React.useEffect(() => {
    if (queryId || seriesId) {
      dispatch(setInitialPathname(pathname));
    }
  }, [queryId, seriesId]);
};
